import PropTypes from 'prop-types';
import { useContext } from 'react';
import { ToastContext, AlloyButton } from 'cat-ecommerce-alloy';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { emailCart } from '../../../../../../../store/orders/actions';
import styles from './EmailToCartButton.module.scss';

const EmailToCartButton = ({ className }) => {
  const toastCtx = useContext(ToastContext);
  const [t] = useTranslation();
  const dispatch = useDispatch();
  const { isEmailCartLoading } = useSelector(s => s.orders);
  const emailToCartSubmit = () => {
    dispatch(emailCart()).then(isSuccess => {
      if (isSuccess) {
        toastCtx.destroyAllToasts();
        toastCtx.createSuccessToast(t('EMAIL_SHOPPING_CART_ITEMS'));
      }
    });
  };
  return (
    <>
      <AlloyButton
        buttonType="primary"
        size="dynamic"
        className={`${styles['email-cart__btn']} ${className ? className : ''}`}
        onClick={emailToCartSubmit}
        disabled={isEmailCartLoading}
      >
        {t('EMAIL_SHOPPING_CART')}
      </AlloyButton>
    </>
  );
};

EmailToCartButton.propTypes = {
  className: PropTypes.string
};

export default EmailToCartButton;
